<dx-popup
   [resizeEnabled]="true"
   [dragEnabled]="true"
   [title]="this.title"
   [visible]="this.isVisible"
   (onShown)="this.onShown()"
   (onHidden)="this.onHidden()"
   height="auto"
   [width]="460"
   [minWidth]="400"
   >
   <div *dxTemplate="let data of 'content'" class="content-wrapper" #wrapper>

      <!-- CR-20260910-001 (2026-09-14): Maven's own dialog, split out of ORION Settings. Two
           settings today (owner): the display limit and the range cap. Same layout: a setting is TWO rows - label left + input right on
           one line, help text full-width beneath. Fixed 460px width (owner: the 18vw of the ORION
           dialog was too narrow for the contents). -->
      <div class="sections">

         <fieldset class="section maven" data-element="maven-settings">
            <legend>MAVEN</legend>

            <div class="setting">
               <div class="row">
                  <div class="label">Show top N results</div>
                  <div class="input">
                     <dx-number-box [(value)]="this.showTopN"
                                    [showSpinButtons]="true"
                                    [step]="1"
                                    format="#0"
                                    [inputAttr]="{style: 'text-align: center'}"
                     ></dx-number-box>
                  </div>
               </div>
               <div class="help">Max amount of result cards MAVEN draws. Every package the run produced stays in memory; this only limits the display. Default 5.</div>
            </div>

            <div class="setting">
               <div class="row">
                  <div class="label">Max Query Range (days)</div>
                  <div class="input">
                     <dx-number-box [(value)]="this.maxQueryRangeDays"
                                    [showSpinButtons]="true"
                                    [step]="1"
                                    format="#0"
                                    [inputAttr]="{style: 'text-align: center'}"
                     ></dx-number-box>
                  </div>
               </div>
               <div class="help">Max width of a MAVEN query's date range in calendar days, counted from its start date. Default 21.</div>
            </div>

            <!-- CR-20260921-003 (owner rulings 2026-09-21): the per-expiration cap. Every hedge
                 pair of every day is ranked in ONE list by credit per day; at most this many
                 cards of one expiration are kept. A backend cut, not a display limit. -->
            <div class="setting" data-element="maven-settings-max-results-per-expiration">
               <div class="row">
                  <div class="label">Max Results for the Expiration</div>
                  <div class="input">
                     <dx-number-box [(value)]="this.maxResultsPerExpiration"
                                    [showSpinButtons]="true"
                                    [step]="1"
                                    format="#0"
                                    [inputAttr]="{style: 'text-align: center'}"
                     ></dx-number-box>
                  </div>
               </div>
               <div class="help">Max amount of result cards a single expiration may contribute. MAVEN ranks every adjustment + hedge pair of every expiration together by credit per day and keeps at most this many per expiration. A single-date run always keeps at least two. Default 2.</div>
            </div>

            <!-- CR-20260915-002: "Weekdays to exclude" (owner sketch, 2026-09-15): five boxes,
                 the day's name above and a checkbox below. Checked = Maven's Date Range starts
                 with that weekday excluded; the trader may still toggle it per query. Maven's OWN
                 set - the APG ORION's lives in the ORION Settings dialog. -->
            <div class="setting" data-element="maven-settings-weekdays">
               <div class="label">Weekdays to exclude</div>
               <div class="weekdays">
                  <div class="weekday" *ngFor="let box of this.weekdayExclusions"
                       [attr.data-element]="'weekday-' + box.id">
                     <div class="weekday-label">{{ box.text }}</div>
                     <dx-check-box [value]="box.checked"
                                   (onValueChanged)="this.onWeekdayChanged(box, $event)"></dx-check-box>
                  </div>
               </div>
               <div class="help">Weekdays taken out of a MAVEN date range by default. The trader can still toggle any day per query. Default: none.</div>
            </div>
         </fieldset>

      </div>

      <div class="buttons">
         <div class="button">
            <dx-button text="Save" width="100%" (onClick)="this.onSaveClicked()"></dx-button>
         </div>
         <div class="button">
            <dx-button text="Close" width="100%" (onClick)="this.onCloseClicked()"></dx-button>
         </div>
      </div>

      <dx-load-panel [visible]="this.isLoading" [position]="{my: 'center', at: 'center', of: wrapper}"></dx-load-panel>

   </div>
</dx-popup>
